export const oneOfArgsTruthyUtil = (...args) => args.reduce((acc, curr) => (curr ? true : acc), false);
export default oneOfArgsTruthyUtil;
